import { decorate, observable, action } from 'mobx';
import { EventKey, Key } from "@gp/models";

const ALTERNATE_BETTING_TYPES = [
	"team-point-over-under",
	"handicap-incl-overtime",
	"total-incl-overtime",
	"team-over-under",
	"point-handicap-hcp-incl-overtime",
	"spread"
]

class EventKeyOffer extends EventKey {
	constructor(key: EventKey) {
		super();

		this.id = key.id;
		this.bettingTypeId = key.bettingTypeId;
		this.bettingType = key.bettingType;
		this.eventId = key.eventId;
		this.isFavorite = !!key.isFavorite;
		this.isLocked = !!key.isLocked;
		this.specifier = key.specifier;
		this.betBuilder = key.betBuilder;

		this.setAlternate();
	}

	/**
	 * @param key new key data
	 */
	update(key: Key) {

		this.isFavorite = !!key.isFavorite;
		this.isLocked = !!key.isLocked;
		this.specifier = key.specifier;
		this.betBuilder = key.betBuilder;

		this.setAlternate();
	}

	setAlternate() {
		if (ALTERNATE_BETTING_TYPES.includes(this.bettingType?.abrv)) {
			this.isAlternate = !this.isFavorite;
		} else {
			this.isAlternate = false;
		}
	}
}

decorate(EventKeyOffer, {
	isFavorite: observable,
	isLocked: observable,
	isAlternate: observable,
	betBuilder: observable,
	update: action.bound,
	setAlternate: action.bound,
})

export {
	EventKeyOffer
}